import { createFileRoute } from "@tanstack/react-router";
import { MobileTimerPage } from "@/features/timesheet/MobileTimerPage";

export const Route = createFileRoute("/_app/time/timer")({
  component: MobileTimerPage,
});
